<script setup>
  import { computed } from 'vue';
  import DataContainer from "@/components/DataContainer.vue";
  import CurrentConditionsGauge from "@/components/CurrentConditionsGauge.vue";

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const upgrade = computed(() => props.upgrade);
</script>

<template>
  <DataContainer class="jwx-complete-report-gauge" >
    <CurrentConditionsGauge :upgrade="upgrade" />
  </DataContainer>
</template>